import React from 'react'
import { Link } from 'react-router-dom';

const EventShow = () => {
  return (
    <div>
        
          <Link to="/event" className=" th-icon">
                                             Back
                                              </Link>
                                              <section class="th-blog-wrapper space-top space-extra-bottom">
                                              <img src="assets/img/category/category_1_5.png" alt="Image"/>
        <div class="container">
            <div class="row">
                <div class="col-xxl-8 col-lg-7">
                    <div class="th-blog blog-single has-post-thumbnail">
                        <div class="blog-img">
                            <a href="blog-details.html"><img src="assets/img/category/category_1_5.png" alt="Blog Image"/></a>
                        </div>
                        <div class="blog-content">
                            <div class="blog-meta">
                                <a class="author" href="blog.html"><i class="fa-light fa-user"></i>by David Smith</a>
                                <a href="blog.html"><i class="fa-solid fa-calendar-days"></i>05 May,
                                    2025</a>
                                <a href="blog-details.html"><img src="assets/img/icon/map.svg" alt=""/>Tour Guide</a>
                            </div>
                            <h2 class="blog-title"><a href="blog-details.html">Living sustainability: A day in the life at
                                    realar residence</a>
                            </h2>
                            <p class="blog-text">Uniquely pursue emerging experiences before liemerging content. Efficiently
                                underwhelm customer directed total linkage after B2C synergy. Dynamically simplify superior
                                human capital whereas efficient infrastructures generate business web-readiness after
                                wireless outsourcing.</p>
                            <a href="blog-details.html" class="th-btn style4 th-icon">Read More</a>
                        </div>
                    </div>
                  
                   
                </div>
              
            </div>
        </div>
    </section>                                      
    </div>
  )
}

export default EventShow